export default "__VITE_ASSET__4d7d5eed__"